<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.detail.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="\[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.detail.$invalid },]")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          h2 {{ this.detail.project_name }}
          b-form-group
            vm-input(
              :danger-text="$t('validation.required', { attribute: $t('projects.project_name') })" v-model="detail.project_name"
              :disabled="additional" autofocus
              :label='$t("projects.project")' required
              :placeholder='$t("projects.project_name_placeholder")')
          b-form-group
            vm-typeahead(:disabled="additional" autofocus url="customers" :label='$t("projects.customer_id")' disable-match :danger="$v.detail.customer.$invalid && $v.detail.customer.$model" :danger-text="$t('validation.required', { attribute: $t('projects.customer') })" :serializer="item => item.name" required :data="toQuotesCatalog.customers" :placeholder='$t("projects.customer_id_placeholder")' v-model="detail.customer" :filter="query => `?param=${query},name&is_employee=0`" @input-change="autoCompleteFunc" :default-value="detail.customer ? detail.customer.name : null")
              template(slot-scope="{data}")
                vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
          b-form-group
            vm-input(:placeholder='$t("projects.amount")' :danger="$v.detail.amount.$invalid && $v.detail.amount.$model" :danger-text="$t('validation.required', { attribute: $t('projects.amount') })" v-model="detail.amount" :label='$t("projects.amount")' required)

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalInOrdersDetail',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    form: {}
  }),
  validations: {
    detail: {
      customer: {
        required
      },
      amount: {
        required
      }
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'inOrdersCatalog',
      'toQuotesCatalog'
    ]),
    getTitle () {
      return this.$t('strings.edit')
    }
  },
  methods: {
    ...mapActions([
      'addInOrderDetail',
      'editInOrderDetail',
      'setModalVisible',
      'loadCatalogCustomer'
    ]),
    async saveRecord () {
      this.form.customer = this.detail.customer.id
      this.form.amount = this.detail.amount
      this.form.project_name = this.detail.project_name
      this.form.id_proyect = this.detail.id
      await this.editInOrderDetail(this.form)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalogCustomer({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    },
    watch: {
      'detail.product' (product) {
        this.detail.unit_price = product.price
      }
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
